import React from 'react';
import {
  Show,
  ShowProps,
  SimpleShowLayout,
  useShowController,
  FileField,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { Divider } from '@material-ui/core';
import UserDataBlock from '../../../../components/UserDataBlock';
import NutritionAdviceQuestionnaireAnswers from '../../../../components/NutritionAdviceQuestionnaireAnswers/index';
import NutritionAdviceConsultationForm from '../../../../components/NutritionAdviceConsultationForm/index';
import TestActivationAnswers from '../../../../components/TestActivationAnswers/index';
import TestResults from '../../../../components/TestResults';

import '../styles.scss';
import HealthRiskCheckConfigurator from '../../../../components/HealthRiskCheckConfigurator';
import NutritionAdviceFoodJournal from '../../../../components/NutritionAdviceFoodJournal';
import { TestNames } from '../../../../constants/test/testNames';

const NutritionAdvice = (props: ShowProps) => {
  const translate = useTranslate();
  const { record } = useShowController(props);

  return (
    <Show {...props} className="treatments-show">
      <SimpleShowLayout>
        <UserDataBlock record={record} />
        <Divider className="divider" />
        <TestActivationAnswers record={record} />
        <Divider className="divider" />
        <FileField
          target="_blank"
          className="text--purple"
          source="test.labReport"
          title={translate('testResults.openLabReport') as string}
          label="testResults.labReport"
        />
        <FunctionField
          className="text"
          render={() => TestNames[record?.test?.type as keyof typeof TestNames]}
          label="testResults.testType"
        />
        {record && (
          <TestResults
            data={record.test.results.tests}
            partnerCode={record.test.partnerCode}
            userInfo={record.test.user}
          />
        )}
        <Divider className="divider" />
        <HealthRiskCheckConfigurator
          record={record}
          currentResource="tests/healthCheckBasic"
          readOnly
        />
        <Divider className="divider" />
        <NutritionAdviceQuestionnaireAnswers record={record} />
        <Divider className="divider" />
        <NutritionAdviceFoodJournal record={record} />
        <Divider className="divider" />
        <NutritionAdviceConsultationForm record={record} />
      </SimpleShowLayout>
    </Show>
  );
};

export default NutritionAdvice;
